import { getStyledSystemProps } from '~/utils/styled-system';
import { StyledSelect } from '../../select.style';
import { MONTH_OPTIONS } from './constants';
import { Requirements, MonthContainer } from './month.style';

export const Month = ({ onChange, value, label, requirements, ...rest }) => {
  const handleChange = (value: number | string) => {
    onChange(value, { isValid: !!value, name: 'month' });
  };

  return (
    <MonthContainer>
      <StyledSelect
        {...getStyledSystemProps(rest)}
        id="month"
        label={label || 'Choose a month from the dropdown'}
        minHeight="auto"
        name="month"
        onChange={handleChange}
        options={MONTH_OPTIONS}
        value={value}
        withEmptyPlaceholder
      />
      {!!requirements && <Requirements>{requirements}</Requirements>}
    </MonthContainer>
  );
};
